import React, { useState, useEffect } from 'react';
import { lessonsAPI, jobClientsAPI, touristClientsAPI, jobApiError } from '../services/api';
import './ClientVertical.css';

const APP_ACCESS = { job: (id) => jobClientsAPI.issueLoginSetup(id), tourist: (id) => touristClientsAPI.issueLoginSetup(id) };

// Read-only "Turkish lessons" summary on a client's record: lessons left, level
// and last lesson, for whoever can already open the record. Teaching notes and
// payments stay on the Language Lessons page. For job seekers and tourists it
// also carries "Give app access", since they have no other app login.
export default function LessonsPanel({ kind, clientId }) {
  const [state, setState] = useState({ loading: true });
  const [access, setAccess] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    let live = true;
    lessonsAPI.summary(kind, clientId)
      .then((r) => live && setState({ learner: r.data.learner }))
      .catch(() => live && setState({ hidden: true }));  // not for this role
    return () => { live = false; };
  }, [kind, clientId]);

  if (state.loading || state.hidden) return null;
  const l = state.learner;
  const giveAccess = async () => {
    try { setAccess((await APP_ACCESS[kind](clientId)).data); setErr(''); } catch (e) { setErr(jobApiError(e, 'Could not create the app login.')); }
  };
  const start = async () => {
    try { await lessonsAPI.startLearner({ kind, client_id: clientId }); setState({ learner: (await lessonsAPI.summary(kind, clientId)).data.learner }); } catch (e) { setErr(jobApiError(e)); }
  };

  return (
    <div className="cv-subsection" style={{ margin: '16px 20px 0' }}>
      <div className="cv-subsection-title"><span>Turkish lessons</span></div>
      {err && <div className="error-message" style={{ marginBottom: 8 }}>{err}</div>}
      {!l && (
        <div className="cv-subsection-empty">
          Not taking lessons. <button type="button" className="btn-secondary" onClick={start}>Start lessons</button>
        </div>
      )}
      {l && (
        <div style={{ fontSize: 13 }}>
          <span className="status-pill" style={{ color: l.lessons_left <= 0 ? '#b91c1c' : l.lessons_left <= 2 ? '#b45309' : '#15803d' }}>
            {l.lessons_left <= 0 ? 'No lessons left' : `${l.lessons_left} lesson(s) left`}
          </span>{' '}
          Level: {l.level || 'not set'}{l.progress.total ? ` (${l.progress.done} of ${l.progress.total} sub-topics)` : ''}
          {' · '}Last lesson: {l.last_lesson_at ? new Date(l.last_lesson_at).toLocaleDateString() : 'none yet'}
          {l.status !== 'ACTIVE' && ` · ${l.status.toLowerCase()}`}
          <div style={{ marginTop: 4 }}>Teacher: {l.teachers?.length ? l.teachers.join(', ') : 'none yet'}</div>
          <div style={{ color: '#64748b', fontSize: 12, marginTop: 4 }}>Classes, packages and the schedule are on the Language Lessons page.</div>
        </div>
      )}
      {APP_ACCESS[kind] && (
        <div style={{ marginTop: 8, fontSize: 12 }}>
          <button type="button" className="btn-secondary" onClick={giveAccess}>Give app access</button>
          {access && (
            <div style={{ marginTop: 6, wordBreak: 'break-all' }}>
              {access.link
                ? <>Send this link to {access.client_email} so they can set a password (works for {access.expires_hours} hours): {access.link}</>
                : 'App login created, but no set-password page address is configured in Settings.'}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
